var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "variation-tags-wrapper d-flex flex-wrap pt-md-3 pl-md-3 mt-3",
    },
    _vm._l(_vm.variationTags, function (ref) {
      var selection = ref.selection
      var value = ref.value
      return _c("span", { key: selection.propertyId }, [
        _c(
          "span",
          {
            staticClass: "badge",
            style: {
              color: selection.color,
              backgroundColor: selection.bgcolor,
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  selection.texts[_vm.lang].replace("$1", value.values.value)
                ) +
                "\n    "
            ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }